import { CustomRulesInput, CustomRulesOutput } from '@allocab/allocab-passenger-shared-types';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { queryKeys } from '../services/datastore/queryKeys';
import { queryClient } from '../services/datastore/react-query';
import { passengerApi } from '../services/network/Api';
import { QueryOptions } from '../services/types';

const fetchCustomRules = () =>
  passengerApi.get<CustomRulesInput, CustomRulesOutput>('/account/v1/custom-rules', { proPerso: 'PRO' });

export const useFetchCustomRules = (
  options: QueryOptions<typeof queryKeys.user.fetchCustomRules, CustomRulesOutput> = {},
) => useQuery(queryKeys.user.fetchCustomRules(), fetchCustomRules, options);

export const usePrefetchCustomRules = () => {
  useEffect(() => {
    queryClient.prefetchQuery(queryKeys.user.fetchCustomRules(), fetchCustomRules);
  }, []);
};
